import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { PaginationCommitIgnoredEvent } from './events/PaginationCommitIgnoredEvent';
import { IGetters } from './interfaces/IGetters';
import { IMutations } from './interfaces/IMutations';
import { PaginationCommittedEvent } from './events/PaginationCommittedEvent';

export class ActionCommitPagination {
	private readonly eventAggregationService: IEventAggregationService;
	private readonly getters: IGetters;
	private readonly mutations: IMutations;

	public constructor(getters: IGetters, mutations: IMutations, eventAggregationService: IEventAggregationService) {
		this.getters = getters;
		this.mutations = mutations;
		this.eventAggregationService = eventAggregationService;
	}

	public commit(page: number | null, correlationId: number): void {
		const isCommitted = page === this.getters.getCurrentPageNumber();
		if (isCommitted) {
			this.publishCommitIgnored(correlationId);
			return;
		}

		page = this.validate(page);

		this.mutations.setPageNumber(page);
		this.publishCommitted(correlationId);
	}

	private validate(page: number | null): number {
		return typeof page === 'number' && page > 0 ? page : 1;
	}

	private publishCommitIgnored(correlationId: number): void {
		this.eventAggregationService.publishTo(
			PaginationCommitIgnoredEvent.EventType,
			new PaginationCommitIgnoredEvent(correlationId)
		);
	}

	private publishCommitted(correlationId: number): void {
		this.eventAggregationService.publishTo(
			PaginationCommittedEvent.EventType,
			new PaginationCommittedEvent(correlationId)
		);
	}
}
